export default {"src":"/_next/static/media/ic_camera.806b7244.svg","height":14,"width":18,"blurWidth":0,"blurHeight":0};